<div class="card-content register-card-content">
  <h3 class="register-card-title">{{ 'modify-info.title' | translate }}</h3>

  <div class="confirm-body">
    <div class="confirm-body-item">
      <p class="confirm-body-item-title">
        {{ 'modify-info.gender' | translate }}
      </p>
      <p>
        {{
          gender === API_PARAMS.GENDER.MALE
            ? ('modify-info.male' | translate)
            : ('modify-info.female' | translate)
        }}
      </p>
    </div>
  </div>
  <div class="confirm-body">
    <div class="confirm-body-item">
      <p class="confirm-body-item-title">
        {{ 'modify-info.birthday' | translate }}
      </p>
      <p>{{ birthday }}</p>
    </div>
  </div>
  <div class="confirm-body">
    <div class="confirm-body-item">
      <p class="confirm-body-item-title">
        {{ 'modify-info.name' | translate }}
      </p>
      <div class="confirm-body-item-btn">
        <p>{{ name }}</p>
        <button
          mat-button
          class="btn-outline-primary btn-size-M"
          (click)="openModifyNameDialog()"
        >
          {{ 'modify-info.modify-name' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="confirm-body">
    <div class="confirm-body-item">
      <p class="confirm-body-item-title">
        {{ 'modify-info.id-number' | translate }}
      </p>
      <p>{{ idNumber }}</p>
    </div>
  </div>
  <div class="confirm-body">
    <div class="confirm-body-item">
      <p class="confirm-body-item-title">
        {{ 'modify-info.phone' | translate }}
      </p>
      <div class="confirm-body-item-btn">
        @if (phone) {
          <div class="confirm-body-item-verify">
            <p>{{ phone }}</p>
            <span
              >{{ 'modify-info.verified' | translate
              }}<img
                width="20"
                height="20"
                ngSrc="assets/img/i-success-fill-green.svg"
                alt=""
            /></span>
          </div>
        } @else {
          <p>{{ 'modify-info.bind-phone-hint' | translate }}</p>
        }
        &nbsp;
        <button
          mat-button
          (click)="openSavePhoneDialog()"
          class="btn-outline-primary btn-size-M"
        >
          {{
            phone
              ? ('modify-info.modify-phone' | translate)
              : ('modify-info.add-phone' | translate)
          }}
        </button>
      </div>
    </div>
  </div>

  <div class="confirm-body">
    <div class="confirm-body-item">
      <p class="confirm-body-item-title">
        {{ 'modify-info.email' | translate }}
      </p>
      <div class="confirm-body-item-btn">
        <div class="confirm-body-item-verify">
          <p>{{ email }}</p>
          <span
            >{{ 'modify-info.verified' | translate
            }}<img
              width="20"
              height="20"
              ngSrc="assets/img/i-success-fill-green.svg"
              alt=""
          /></span>
        </div>
        <button
          mat-button
          (click)="openModifyEmailDialog()"
          class="btn-outline-primary btn-size-M"
        >
          {{ 'modify-info.modify-email' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="input-block">
    <label class="input-title">{{
      'modify-info.modify-password' | translate
    }}</label>
    <div class="input-password-block">
      <div class="input-group input-btn-right">
        <input
          matInput
          [type]="isPasswordVisible ? 'text' : 'password'"
          [formControl]="currentPasswordControl"
          [ngClass]="{
            'input-error': showPasswordError && currentPasswordControl.invalid,
          }"
          [placeholder]="'modify-info.origin-password-placeholder' | translate"
        />
        <button
          mat-icon-button
          type="button"
          (click)="togglePasswordVisibility()"
          class="input-password-btn"
        >
          <img
            [src]="
              isPasswordVisible
                ? 'assets/img/i-eye.svg'
                : 'assets/img/i-eye-closed.svg'
            "
            alt="toggle visibility"
          />
        </button>
      </div>
      <button
        mat-button
        (click)="modifyPassword()"
        class="btn-outline-primary btn-size-M"
        [disabled]="isPasswordChangeDisabled"
        [ngClass]="{ 'btn-disabled': isPasswordChangeDisabled }"
      >
        {{ 'modify-info.modify-password' | translate }}
      </button>
    </div>
    @if ((showPasswordError && passwordErrorMessage) || currentPasswordControl.invalid ) {
      <mat-error class="input-error-msg">{{ passwordErrorMessage }}</mat-error>
    }
    @if (isPasswordChangeDisabled) {
    <div class="password-change-hint">
      <img
              width="16"
              height="16"
              ngSrc="assets/img/i-warn-outline.svg"
              alt=""
      />
      <span>{{ 'modify-info.password-change-daily-limit' | translate }}</span>
    </div>
    }
  </div>
<!--測試按鈕-->
<!-- <div class="btn-test">
  <mat-button-toggle-group>
    <mat-button-toggle (click)="phone = '0987654321'">有手機</mat-button-toggle>
    <mat-button-toggle (click)="phone = undefined">無手機</mat-button-toggle>
  </mat-button-toggle-group>
</div> -->
